<template>
  <div class="coming-soon-container">
    <div class="banner-wrapper">
      <img :src="require('@/assets/images/coming-soon.png')" alt="Coming Soon" />
    </div>
    <div class="sub-banner">
      <div class="coming-soon-title">
        <h1>{{ title }}</h1>
        <div class="subtitle-with-image">
            <img v-if="titleImage" :src="titleImage" alt="Title Image" class="title-image" />
          <h2>{{ subtitle }}</h2>
        </div>
      </div>
      <div class="description">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonPressRelease',
  props: {
    title: String,
    subtitle: String,
    description: String,
    titleImage: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.coming-soon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url('~@/assets/images/container-image.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  gap: 14px;
}

.banner-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.banner-wrapper img {
  height: 150px;
  width: auto;
}

.sub-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap:10px
}

.coming-soon-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coming-soon-title h1 {
  font-size: 16px;
  font-weight: 600;
  color: black;
}

.subtitle-with-image {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px; 

}

.subtitle-with-image h2 {
    font-size: 30px;
    background: var(--primary-gradient-with-white);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
}

.title-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.description {
  font-size: 16px;
  line-height: 1.6;
  max-width: 400px;
  color:#737373;
  font-style: italic;

}
</style>
